import React, { useEffect, useState } from "react";
import {
	Block,
	BlockContent,
	BlockDes,
	BlockHead,
	BlockTitle,
	Button,
	Icon,
	PreviewCard,
} from "../../components/Component";
import Logo from "../../images/logo.png";
import LogoDark from "../../images/logo-dark.png";
import { Form, FormGroup, Spinner, Alert, Toast, ToastHeader, ToastBody } from "reactstrap";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import { useForm } from "react-hook-form";
import { Link, } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { loginAxios } from '../../config/axios.config';
import { useSelector, useDispatch } from "react-redux";

// import useCustomToast from "../../utils/useCustomToast";

import { toast, ToastContainer } from "react-toastify";

const Login = () => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [passState, setPassState] = useState(false);
	const [errorVal, setError] = useState("");

	const { errors, register, handleSubmit } = useForm();
	const [visible, setVisible] = useState(false)
	const [toastMsg, setToastMsg] = useState('');


	// const clickedButton = useCustomToast(0 , "Login Component"); 

	// const { ToastContainer, resetCounter, setToastMessage, handleToastTitle } = useCustomToast(false, 'Login');

	const registerSuccess = useSelector((state) => state.profileReducer.registerSuccess);
	const resetPassSuccess = useSelector((state) => state.profileReducer.resetPassSuccess);

	useEffect(() => {
		const queryString = window.location.search;		
		const urlParams = new URLSearchParams(queryString);
		const user_name = urlParams.get('user_name');
		const pass_code = urlParams.get('pass_code');		

		if(user_name && pass_code) {
			var params = {
				email: user_name,
				password: pass_code
			}
			loginUser.mutate(params);
		}
	}, [])

	useEffect(() => {


		if(resetPassSuccess != '') {

			toast.success(resetPassSuccess, {
				position: "top-right",
				autoClose: 2000,
				hideProgressBar: true,
				closeOnClick: true,
				progress: false,
				onClose: () => {
					dispatch({ type: 'RESET_PASS_SUCCESS_MESSAGE', payload: '' })
				}
			});
		}

		if(registerSuccess != '') {

			toast.success(registerSuccess, {
				position: "top-right",
				autoClose: 2000,
				hideProgressBar: true,
				closeOnClick: true,
				progress: false,
				onClose: () => {
					dispatch({ type: 'REGISTER_SUCCESS_MESSAGE', payload: '' })
				}
			});
		}

	}, [registerSuccess, resetPassSuccess])

	const handleToastVisible = (msg) => {
		setVisible(true);
		setToastMsg(msg);
		setTimeout(() => {
			setVisible(false);
			setToastMsg('');
		}, 1500)

	}

	const loginUserCall = async (params) => {
		try {
			const { data } = await loginAxios.post("designers/login", params);
			return data;

		} catch (error) {
			return Promise.reject(error);
		}
	};

	const loginUser = useMutation(loginUserCall, {
		onSettled(data, error) {
			if (data) {
				// console.log('found data')
				// handleToastVisible(data.message);
				// console.log(data);

				localStorage.setItem("accessToken", data?.data?.token);

				localStorage.setItem('userInitDetails', JSON.stringify(data?.data));
				// localStorage.setItem("userInitDetails", data?.data);

				window.history.pushState(
					`${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/product-catalogue"}`,
					"auth-login",
					`${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/product-catalogue"}`
				);
				window.location.reload();

				// handleToastTitle('Success');
				// setToastMessage(data.message);
				// resetCounter();

			} else if (error) {

				console.log(error);
				console.log(error.response.data.message);

				// console.log('found ERROR')
				// console.log();
				// handleToastVisible(error.response.data.message);

				// handleToastTitle('Error');
				// setToastMessage(error.response.data.message);
				// resetCounter();

				toast.error(error.response.data.message, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: true,
					closeOnClick: true,
					progress: false,
				  });
		  
			}
		}
	})


	const onFormSubmit = (data) => {


		var params = {
			email: data.email,
			password: data.password
		}



		loginUser.mutate(params);

		// setLoading(true);
		// const loginName = "info@softnio.com";
		// const pass = "123456";
		// if (data.name === loginName && data.password === pass) {
		//   localStorage.setItem("accessToken", "token");
		//   setTimeout(() => {
		//     window.history.pushState(
		//       `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/"}`,
		//       "auth-login",
		//       `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/"}`
		//     );
		//     window.location.reload();
		//   }, 2000);
		// } else {
		//   setTimeout(() => {
		//     setError("Cannot login with credentials");
		//     setLoading(false);
		//   }, 2000);
		// }
	};

	return (
		<React.Fragment>
			<Head title="Login" />
			<PageContainer>

				{/* <div>
					<button onClick={() => {
						resetCounter();
						setToastMessage('set some value here....');
						handleToastTitle('Title Head')
					}}>
						Click here!
					</button>
				</div> */}

				{/* <ToastContainer /> */}

				{/* <div style={{ position: "fixed", top: 10, right: 10, zIndex: 9999 }}>
					<Toast isOpen={visible}>
						<ToastHeader>
							Toast title
						</ToastHeader>
						<ToastBody>
							{toastMsg}
						</ToastBody>
					</Toast>
				</div> */}

				<Block className="nk-block-middle nk-auth-body  wide-xs">
					<div className="brand-logo pb-4 text-center">
						<Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
							<img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
							<img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
						</Link>
					</div>

					<PreviewCard className="card-bordered" bodyClass="card-inner-lg">
						<BlockHead>
							<BlockContent>
								<BlockTitle tag="h4">Sign-In</BlockTitle>
								<BlockDes>
									<p>Access Designer Panel using your email and password.</p>
								</BlockDes>
							</BlockContent>
						</BlockHead>
						{errorVal && (
							<div className="mb-3">
								<Alert color="danger" className="alert-icon">
									{" "}
									<Icon name="alert-circle" /> Unable to login with credentials{" "}
								</Alert>
							</div>
						)}
						<Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
							<FormGroup>
								<div className="form-label-group">
									<label className="form-label" htmlFor="default-01">
										Email
									</label>
								</div>
								<div className="form-control-wrap">
									<input
										type="text"
										id="default-01"
										name="email"
										ref={register({
											required: "This field is required",
											pattern: {
												value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
												message: "Please enter valid email-id",
											},
										})}
										// defaultValue="info@softnio.com"
										placeholder="Enter your email address"
										className="form-control-lg form-control"
									/>
									{errors.email && <span className="invalid">{errors.email.message}</span>}
								</div>
							</FormGroup>
							<FormGroup>
								<div className="form-label-group">
									<label className="form-label" htmlFor="password">
										Password
									</label>
									<Link className="link link-primary link-sm" to={`${process.env.PUBLIC_URL}/auth-reset`}>
										Forgot Password?
									</Link>
								</div>
								<div className="form-control-wrap">
									<a
										href="#password"
										onClick={(ev) => {
											ev.preventDefault();
											setPassState(!passState);
										}}
										className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
									>
										<Icon name="eye" className="passcode-icon icon-show"></Icon>

										<Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
									</a>
									<input
										type={passState ? "text" : "password"}
										id="password"
										name="password"
										// defaultValue="123456"
										ref={register({
											required: "This field is required",
											// pattern: {
											// 	value: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
											// 	message: "Min 8 letter, with at least a symbol, upper and lower case letters and a number",
											// },
										})}
										placeholder="Enter your password"
										className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
									/>
									{errors.password && <span className="invalid">{errors.password.message}</span>}
								</div>
							</FormGroup>
							<FormGroup>
								<Button size="lg" className="btn-block" type="submit" color="primary">
									{loginUser.isLoading ? <Spinner size="sm" color="light" /> : "Sign in"}
								</Button>
							</FormGroup>
						</Form>
						<div className="form-note-s2 text-center pt-4">
							{" "}
							New on our platform? <Link to={`${process.env.PUBLIC_URL}/auth-register`}>Create an account</Link>
						</div>
						{/* <div className="text-center pt-4 pb-3">
              <h6 className="overline-title overline-title-sap">
                <span>OR</span>
              </h6>
            </div> */}
						{/* <ul className="nav justify-center gx-4">
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#socials"
                  onClick={(ev) => {
                    ev.preventDefault();
                  }}
                >
                  Facebook
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#socials"
                  onClick={(ev) => {
                    ev.preventDefault();
                  }}
                >
                  Google
                </a>
              </li>
            </ul> */}
					</PreviewCard>
				</Block>
				{/* <AuthFooter /> */}
			</PageContainer>
			<ToastContainer />
		</React.Fragment>
	);
};
export default Login;
